import type {AgentProfile, ChatInputSlotProps, LeadingIconSlotProps} from '../agent-profile'
import {AGENT_INFO_REGISTRY} from '../agent-profile'
import {VscodeSessionIcon} from '../../components/VscodeSessionIcon'
import {EmptyCliSession} from '../../components/session-logs/EmptyCliSession'
import {CLIChatInput} from '../../components/task-view/CLIChatInput'
import {computeConnectionStatus} from '../../utils/connection-status'
import {ConnectionStatus} from '../../types/session'
import type {SessionState} from '../../types/session'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {REMOTABLE_BASE} from './remotable-base'

function VSCodeLeadingIcon({staleAt, dataUpdatedAt, state}: LeadingIconSlotProps) {
  const connectionStatus = computeConnectionStatus(staleAt, true, state as SessionState, dataUpdatedAt)
  const isConnected =
    isFeatureEnabled('copilot_mission_control_cli_session_status') && connectionStatus === ConnectionStatus.Connected

  return <VscodeSessionIcon showConnectedDot={isConnected} />
}

function RemotableChatInputSlot({session, task, onCommandSent, cliRemoteNoticeDismissed}: ChatInputSlotProps) {
  const remoteSteerable = task?.remote_steerable === true
  const agentTaskId = task?.agent_collaborators?.[0]?.agent_task_id
  return (
    <CLIChatInput
      session={session}
      remoteSteerable={remoteSteerable}
      agentTaskId={agentTaskId}
      staleAt={task?.stale_at}
      onCommandSent={onCommandSent}
      cliRemoteNoticeDismissed={cliRemoteNoticeDismissed}
    />
  )
}

/**
 * Profile overrides for the VS Code Chat agent.
 * Extends the remotable base with VS Code-specific icon and identity.
 */
export const VSCODE_PROFILE: Partial<AgentProfile> = {
  ...REMOTABLE_BASE,
  slug: 'vscode-chat',
  displayName: 'Copilot in VS Code',

  agentInfo: AGENT_INFO_REGISTRY['vscode-chat'],

  slots: {
    LeadingIcon: VSCodeLeadingIcon,
    ChatInput: RemotableChatInputSlot,
    EmptyState: EmptyCliSession,
  },
}
